<fk-modal-base-container [title]="title" [footer]="modalFooter">
  <div class="fk-modal-content fk-profile-modal fk-text">
    <div class="fk-profile-modal__custom-title fk-h5 fk-mb5">
      {{ 'profile-popup.title' | translate }}
    </div>
    <div class="fk-profile-modal__profile-photo fk-mb5">
      <div class="fk-profile-photo fk-h1">
        {{ getShortenedName(userInfo.name || userInfo.email) }}
      </div>
    </div>
    <div class="fk-profile-form ">
      <fk-form-control class="fk-profile-modal__form-control fk-mb5" [label]="'profile-popup.user-name' | translate" [control]="userNameControl">
        <div class="fk-form-group">
          <input
            class="fk-form-control"
            type="text"
            [formControl]="userNameControl"
            [placeholder]="'profile-popup.user-name-placeholder' | translate"
          />
        </div>
      </fk-form-control>
      <fk-form-control class="fk-profile-modal__form-control fk-mb5" [label]="'profile-popup.email' | translate">
        <div class="fk-form-group">
          <input
            class="fk-form-control"
            type="text"
            [disabled]="true"
            [value]="userInfo.email"
          />
        </div>
      </fk-form-control>
      <fk-form-control class="fk-profile-modal__form-control fk-mb5" [label]="'profile-popup.role' | translate">
        <div class="fk-form-group">
          <input
            class="fk-form-control"
            type="text"
            [disabled]="true"
            [value]="userInfo.role | uppercase"
          />
        </div>
      </fk-form-control>
    </div>

    <fk-form-control class="fk-profile-modal__form-control fk-mb5" [label]="'profile-popup.organizations' | translate">
      <div class="fk-profile-modal__organizations-list">
        <ng-container *ngFor="let organization of sharedOrganizations$ | async; let index = index">
          <fk-tag *ngIf="index <= baseOrganizationVisibleLength || toggleOrganizationList" [selected]="organization.id === selectedOrgId">{{ organization.name }}</fk-tag>
        </ng-container>
        <button
          *ngIf="userInfo.sharedOrgs.length > baseOrganizationVisibleLength"
          class="fk-profile-modal__toggle-orgs-btn fk-subtitle1"
          (click)="toggleOrganizationList = !toggleOrganizationList"
        >
          +{{ userInfo.sharedOrgs.length - baseOrganizationVisibleLength }} {{ 'profile-popup.more' | translate }}
        </button>
      </div>
    </fk-form-control>
  </div>
</fk-modal-base-container>

<ng-template #modalFooter>
  <div class="fk-modal-container__footer-content">
    <button
      (click)="onCloseModal()"
      class="fk-btn fk-btn-tertiary fk-btn-medium"
    >{{ 'cancel' | translate }}</button>
    <button
      class="fk-btn fk-btn-dark fk-btn-medium"
      [disabled]="userNameControl.invalid || (updateProfileDataLoading$ | async) || !canUpdateData"
      (click)="updateUserProfile()"
    >{{ 'save' | translate }}</button>
  </div>
</ng-template>
